module.exports = __webpack_public_path__ + "img/escalacion.3b37ab37.svg";